export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14">
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-primary-800 leading-tight flex-shrink-0">
              Compare, Evaluate
              <br />
              &amp; Decide Faster
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-md lg:pt-3">
              Superbuy Spreadsheet gives you the tools to organize product data, compare options side by side, and make confident purchasing decisions every time.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="md:col-span-1 bg-background-100 rounded-3xl p-6 md:p-8 hover:-translate-y-1 transition-all duration-300"
              style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}
            >
              <div className="mb-5 rounded-2xl overflow-hidden aspect-video bg-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20dual%20monitor%20computer%20setup%20displaying%20colorful%20side%20by%20side%20product%20comparison%20dashboard%20with%20charts%20and%20data%20tables%2C%20bright%20sunny%20home%20office%20with%20plants%2C%20tech%20savvy%20productive%20workspace%2C%20clean%20organized%20desk%20with%20mechanical%20keyboard%2C%20data%20visualization%20UI%20design%2C%20contemporary%20productivity%20aesthetic%2C%20crisp%20detailed%20infographic%20style%20photography&width=800&height=450&seq=feature-compare-v2-2026&orientation=landscape"
                  alt="Superbuy Spreadsheet comparison tables for product research"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="font-heading text-xl font-semibold text-primary-800 mb-2">
                Comparison Tables
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                Side-by-side product comparisons with prices, ratings, and features organized for quick decision-making.
              </p>
            </div>

            <div className="bg-background-100 rounded-3xl p-6 md:p-8 hover:-translate-y-1 transition-all duration-300"
              style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}
            >
              <div className="mb-5 rounded-2xl overflow-hidden aspect-video bg-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Wall%20mounted%20large%20digital%20calendar%20display%20with%20highlighted%20dates%20and%20colorful%20event%20markers%20in%20modern%20tech%20office%2C%20sleek%20minimalist%20interior%20design%2C%20futuristic%20productivity%20tools%2C%20natural%20light%20from%20floor%20to%20ceiling%20windows%2C%20innovative%20planning%20technology%2C%20clean%20bright%20corporate%20environment%2C%20forward%20thinking%20business%20aesthetic%20photography&width=800&height=450&seq=feature-updated-v2-2026&orientation=landscape"
                  alt="Superbuy Spreadsheet updated 2026 resources"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="font-heading text-xl font-semibold text-primary-800 mb-2 text-center">
                Updated 2026
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed text-center">
                All resources are regularly refreshed with the latest product data, pricing updates, and new category discoveries.
              </p>
            </div>

            <div className="bg-background-100 rounded-3xl p-6 md:p-8 hover:-translate-y-1 transition-all duration-300"
              style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}
            >
              <div className="mb-5 rounded-2xl overflow-hidden aspect-video bg-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Futuristic%20cybersecurity%20command%20center%20with%20holographic%20shield%20projection%20and%20encrypted%20data%20streams%2C%20dark%20sophisticated%20tech%20environment%20with%20glowing%20green%20and%20teal%20interface%20elements%2C%20advanced%20digital%20protection%20concept%2C%20sleek%20modern%20security%20operations%20room%2C%20trust%20and%20safety%20technology%20visualization%2C%20clean%20professional%20cyber%20defense%20aesthetic%20photography&width=800&height=450&seq=feature-safety-v2-2026&orientation=landscape"
                  alt="Superbuy Spreadsheet safety and security guide"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="font-heading text-xl font-semibold text-primary-800 mb-2 text-center">
                Safe Links
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed text-center">
                Verified category links and trusted seller recommendations to protect you from fraudulent listings and scams.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}